/**
 * @author RIAZ JAFFARY
 */

export const WebConstants = {
  INT_ZERO: 0,
  INT_ONE: 1,
  INT_TWO: 2,
  INT_THREE: 3,
  INT_FOUR: 4,
  INT_FIVE: 5,
  SECONDS_IN_A_DAY: 86400000,
  ORIGIN: "WEB",
  DEFAULT_HEADERS: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
  METHOD_TYPE: {
    POST: "POST",
    GET: "GET",
    PUT: "PUT",
    DELETE: "DELETE"
  },
  DATE: {
    FORMAT_YYYY_MM_DD: "yyyy-MM-dd",
    FORMAT_MM_DD_YYYY: "MM-dd-yyyy",
    FORMAT_DD_MM_YYYY: "dd/MM/yyyy",
    DAYS_IN_WEEK: 6,
    LAST_DAY_OF_MONTH: 29
  },
  USER: {
    LOGGED_IN: "CITS_CD_LOGGED_IN_USER", //"currentUser",
    ID: "CITS_CD_USER_ID",
    ORGANIZATION_ID: "CITS_CD_ORGANIZATION_ID",
    TOKEN: "CITS_CD_USER_TOKEN",
    AUTHORITIES: "CITS_CD_AUTHORITIES",
  },
  USER_ROLE: {
    SUPER_ADMIN: "ROLE_SUPER_ADMIN",
    ADMIN: "ROLE_ADMIN",
    MANAGER: "ROLE_MANAGER",
    PEO: "ROLE_PEO",
  },
  STATUS: {
    CODE_SUCCESS: 0,
    MSG_SUCCESS: "success",
    CODE_NOTFOUND: 404,
    MSG_NOTFOUND: "not found",
    CODE_ACCESS_DENIED: "9999",
    CODE: {
      ACTIVE: 1,
      INACTIVE: 2,
    },
    MSG: {
      ACTIVE: "Active",
      INACTIVE: "Inactive",
    },
  },
  OCCUPY_STATUS: {
    OCCUPIED: "Occupied",
    UNOCCUPIED: "Unoccupied",
  },
  SPOT:{
    COLOR: {
      GREEN: "green",
      ORANGE: "orange",
      RED: "red"
    },
    LABEL: {
      GREEN: "green",
      ORANGE: "orange",
      RED: "red"
    }
  },
  ERROR: {
    UNDEFINED_INTERNAL_SERVER: "Internal server error undefined",
    INTERNAL_SERVER: "Internal server error"
  },
  MAP_TAB: {
    CURRENT_SESSION: {
      ID: "CURRENT_SESSION",
      NAME: "Current Expired Sessions",
      ACTIVE_TAB: "activeTabName_currentExpiredSession"
    },
    PAST_SESSION: {
      ID: "PAST_SESSION",
      NAME: "My Records",
      ACTIVE_TAB: "activeTabName_pastSession"
    },
    CALE_AMERICA_SESSION: {
      ID: "CALE_AMERICA_SESSION",
      NAME: "Cale America",
      ACTIVE_TAB: "activeTabName_caleAmerica",
      SELECTED_TAB: "CALE_AMERICA_LIVE_SESSION"
    },
    CALE_AMERICA_LIVE_SESSION: {
      ID: "CALE_AMERICA_LIVE_SESSION",
      NAME: "Cale America",
      ACTIVE_TAB: "activeTabName_caleAmerica"
    },
    CALE_AMERICA_TODAY_SESSION: {
      ID: "CALE_AMERICA_TODAY_SESSION",
      NAME: "Cale America",
      ACTIVE_TAB: "activeTabName_caleAmerica"
    },
    PARK_MOBILE_SESSION: {
      ID: "PARK_MOBILE_SESSION",
      NAME: "Cale America",
      ACTIVE_TAB: "activeTabName_parkMobile",
      DEFAULT_TAB: "PARK_MOBILE_LIVE_SESSION",
      LIVE_SESSION: {
        ID: "PARK_MOBILE_LIVE_SESSION",
        NAME: "Park Mobile",
        ACTIVE_TAB: "activeTabName_parkMobileLiveSession"
      },
      TODAY_SESSION: {
        ID: "PARK_MOBILE_TODAY_SESSION",
        NAME: "Park Mobile",
        ACTIVE_TAB: "activeTabName_parkMobileTodaySession"
      },
    },
    PARK_MOBILE_LIVE_SESSION: {
      ID: "PARK_MOBILE_LIVE_SESSION",
      NAME: "Park Mobile",
      ACTIVE_TAB: "activeTabName_parkMobile"
    },
    PARK_MOBILE_TODAY_SESSION: {
      ID: "PARK_MOBILE_TODAY_SESSION",
      NAME: "Park Mobile",
      ACTIVE_TAB: "activeTabName_parkMobile"
    },
  },
  PAST_SESSION: {
    IMAGE_TAG_DELETED: "DELETED"
  },
  GRAPH: {
    ACTION_TYPE: {
      DAILY: "DAILY",
      WEEKLY: "WEEKLY",
      MONTHLY: "MONTHLY",
      DATE_RANGE: "DATE_RANGE",
    },
    ACTION_TYPE_DAILY: "DAILY",
    ACTION_TYPE_WEEKLY: "WEEKLY",
    ACTION_TYPE_MONTHLY: "MONTHLY",
    ACTION_TYPE_DATE_RANGE: "DATE_RANGE",
  },
  ACTION_BY: {
    PEO: "PEO",
    ADMIN: "ADMIN"
  },
  ACTION_TAKEN: {
    TICKET: "TICKET",
    VEHICLE_LEFT: "VEHICLE_LEFT",
    WARNING_GIVEN: "WARNING_GIVEN",
    PERMIT: "PERMIT",
    PEO_NOT_AVAILABLE: "PEO_NOT_AVAILABLE",
    TICKET_VALUE: "Ticket",
    VEHICLE_LEFT_VALUE: "Vehicle Left",
    WARNING_GIVEN_VALUE: "Warning Given",
    PERMIT_VALUE: "Permit",
    PEO_NOT_AVAILABLE_VALUE: "Peo not available"
  },
  SPOT_STATUS: {
    OCCUPIED: "Occupied",
    UNOCCUPIED: "Unoccupied"
  },
  API_URL: {
    LOGIN: "/api/authenticate",
    LOGOUT: "/api/logout",
    USER: {
      FIND_ALL: "/api/user/find-all-users",
      COMMON_FIND_ALL: "/api/CommonMethod/find-all-users",
      ADD_USER: "/api/user/add-user",
      UPDATE_USER: "/api/user/update-user",
      DELETE_USER: "/api/user/delete-user/",
      ACTIVATE_USER: "/api/user/active-user/",
      FIND_USER_BY_ID: "/api/CommonMethod/find-user-by-id/",
      FIND_ALL_USER_BY_ORGANIZATION: "/api/user/find-by-organization/",
      FORGOT_PASSWORD: "/api/CommonMethod/forgot",
      FORGOT_EMAIL_ADDRESS: "/api/user/forgot-email-address",
      VERIFY_RESET_TOKEN: "/api/CommonMethod/verify/",
      RESET_PASSWORD: "/api/user/reset-password",
      CHANGE_PASSWORD: "/api/CommonMethod/change-password",
      PROFILE: "",
      TERMINATE_USER: "",
      FIND_USER_PRIVILEGES: "/api/user/privilege/findUserPrivilegesByUserId/",
      ADD_USER_PRIVILEGE: "/api/user/privilege/add",
      DELETE_USER_PRIVILEGE: "/api/user/privilege/deleteUserPrivilegeByUserIdAndPrivId/",
    },
    PRIVILEGE: {
      FIND_ALL_PRIVILEGE: "/api/privilege/find-all",
    },
    ROLE_PRIVILEGE_MENU: {
      FIND_ALL_ROLES: "/api/role/find-all-roles",
      FIND_ALL_PRIVILEGES: "/api/privilege/find-all-privileges",
      FIND_PRIVILEGE_BY_ID: "/api/privilege/find-privilege-by-role",
      FIND_MENU_BY_PRIVILEGE_ID: "/api/menu/privilege/find-by-privilege-id",
      ADD_MENU: "/api/menu/privilege/add",
      UPDATE_MENU: "/api/menu/privilege/update",
      ADD_ROLE_PRIVILEGE: "/api/role/privilege/add",
      UPDATE_PRIVILEGE: "/api/privilege/update"
    },
    DESIGNATION: {
      FIND_ALL_DESIGNATIONS: "/api/role/find-all-roles"
    },
    ORGANIZATION: {
      FIND_DETAIL: "/api/organization/find-detail/",
      FIND_ALL_ORGANIZATION: "/api/organization/find-all",
      ADD_ORGANIZATION: "/api/organization/add",
      UPDATE_ORGANIZATION: "/api/organization/update",
      DELETE_ORGANIZATION: "/api/organization/delete/",
      FIND_ORGANIZATION_BY_ID: "/api/organization/find/",
      FIND_ORGANIZATION_DETAIL_BY_ID: "/api/CommonMethod/find/", //FOR ORGANIZATION LOGO.
    },
    LPR_CAMERA : {
      ADD_LPR_CAMERA : "/api/alprcamera/add",
      UPDATE_LPR_CAMERA: "/api/alprcamera/update",
      DELETE_LPR_CAMERA : "/api/alprcamera/delete/",
      FIND_ALL_LPR_CAMERA : "/api/alprcamera/find-all"
    },
    LPR_CAMERA_GROUP : {
      ADD_LPR_CAMERA_GROUP : "/api/alprcamera-group/add",
      UPDATE_LPR_CAMERA_GROUP : "/api/alprcamera-group/update",
      DELETE_LPR_CAMERA_GROUP : "/api/alprcamera-group/delete/",
      FIND_ALL_LPR_CAMERA_GROUP : "/api/alprcamera-group/find-all"
    },
    LPR_WHITELIST : {
      ADD_LPR_WHITELIST : "/api/registered-vehicle/add",
      UPDATE_LPR_WHITELIST : "/api/registered-vehicle/update",
      ADD_MULTIPLE_LPR_WHITELIST : "/api/registered-vehicle/add-multiple",
      DELETE_LPR_WHITELIST : "/api/registered-vehicle/delete/",
      DELETE_ALL_REGISTERED_VEHICLE : "/api/registered-vehicle/delete-all",
      FIND_ALL_LPR_WHITELIST : "/api/registered-vehicle/find-all",
      FIND_WHITELIST_FILE_DATA: "/api/find-whitelist_file_data",
      FILE_UPLOADER_LPR_WHITELIST: "/api/registered-vehicle/upload",
      
    },
    LOOKUP: {
      FIND_ALL_ROLES: "/api/lookup/find-all-roles",
      FIND_ALL_PRIVILEGES: "/api/lookup/find-all-privileges",
    },
    PREFERENCES: {
      FIND_ALL_PREFERENCES: "/api/preference/find-all",
      ADD_PREFERENCES: "/api/preference/add",
      UPDATE_PREFERENCES: "/api/preference/update",
      DELETE_PREFERENCES: "/api/preference/delete/",
    },
    SHIFT_DATA: {
      FIND_ALL:"/api/patrolling-session/find-all-by-organization",
    },
    SHIFT_RAW_DATA: {
      FIND_ALL:"/api/lpr/find-data-by-sessionId/",
    },
    ZONE:{
      ADD_ZONE: "/api/zone/add",
      UPDATE_ZONE: "/api/zone/update",
      DELETE_ZONE: "/api/zone/delete/",
      UPLOAD_ZONE: "/api/zone/upload",
      FIND_ALL_ZONE: "/api/zone/find-all",
      FIND_ZONE_BY_ID: "/api/zone/find-by-id/"
    },
    GEOFENCE:{
      ADD_GEOFENCE: "/api/geofence/add",
      UPDATE_GEOFENCE: "/api/geofence/update",
      DELETE_GEOFENCE: "/api/geofence/delete/",
      DELETE_GEOFENCE_WITH_DETAILS: "/api/geofence/delete-geofence/",
      FIND_ALL_GEOFENCE: "/api/geofence/find-all",
      ADD_BULK_GEOFENCE: "/api/geofence/upload"
    },
    GEOFENCE_DETAIL:{
      ADD_GEOFENCE_DETAIL: "/api/geofencedetail/add",
      UPDATE_GEOFENCE_DETAIL: "/api/geofencedetail/update",
      DELETE_GEOFENCE_DETAIL: "/api/geofencedetail/delete/",
      FIND_ALL_GEOFENCE_DETAIL: "/api/geofencedetail/find-all",
      FIND_GEOFENCE_DETAIL_BY_GEOFENCE_ID: "/api/geofencedetail/find-by-geofenceid/",
      ADD_BULK_GEOFENCE_DETAIL: "/api/geofencedetail/upload",
    },
    GEOFENCE_ZONE:{
      ADD_GEOFENCE_ZONE: "/api/geofence-zone/add",
      UPDATE_GEOFENCE_ZONE: "/api/geofence-zone/update",
      DELETE_GEOFENCE_ZONE: "/api/geofence-zone/delete/",
      DELETE_GEOFENCE_ZONE_BY_GEOFENCE_ID: "/api/geofence-zone/delete-by-geofenceId/",
      FIND_ALL_GEOFENCE_ZONE: "/api/geofence-zone/find-all",
      FIND_GEOFENCE_ZONE_BY_ID: "/api/geofence-zone/find-by-id/"
    },
    PAYMENT_DETAIL_SEARCH:{
      FIND_PAYMENT_DETAIL_BY_LP : "/api/lpr-raw/find-by-paymenttype/Payments/"
    },
    PERMIT_DETAIL_SEARCH:{
      FIND_PERMIT_DETAIL_BY_LP : "/api/lpr-raw/find-by-paymenttype/Permitted/"
    },
    PAYMENT_DETAIL_API:{
      FIND_PAYMENT_DETAIL_FROM_API : "/api/lpr-raw/find-by-paymentgateway/",
      FIND_ALL_TODAY : "/api/lpr-raw/find-by-date"
    },
    PERMIT_DETAIL_API:{
      FIND_PERMIT_DETAIL_FROM_API : "/api/lpr-raw/find-by-paymenttype/Permitted/",
      FIND_ALL_TODAY : "/api/lpr-raw/find-by-service-name/PASSPORT"
    },
    GATEWAY_DATA_DETAIL_SEARCH:{
      FIND_GATEWAY_DATA_DETAIL_BY_LP : "/api/lpr-raw/find-by-numberplate/"
    },
    LPR: {
      FIND_PAST_ACTIONS:"/api/lpr/find-past-actions",
      FIND_ALL:"/api/lpr/find-all",
      FIND_VIOLATION_IMAGE_DETAILS: "/api/lpr/action-image/find/"
    },
    LPR_RAW: {
      FIND_ALL:"/api/lpr-raw/find-all",
      FIND_RAW_DATA_IMAGE_BY_SESSION_ID:"/api/lpr-raw/find-raw-data-images-by-sessionId/",
      FIND_STATS_MONTHLY: "/api/lpr-raw/find-patrolling-session-statistics-by-org",
      FIND_STATS_DAILY: "/api/lpr-raw/find-patrolling-session-daily-statistics-by-org",
      FIND_STATS_HOURLY: "/api/lpr-raw/find-patrolling-session-hourly-statistics-by-org",
      FIND_STATS_ALL: "/api/lpr-raw/find-all-patrolling-session-statistics"
    },
    ANALYTICS: {
      FIND_VIOLATION_BY_MULTI: "/api/analytics/find-violation-by-multi",
      FIND_VIOLATION_BY_ALL_GEOFENCE: "/api/analytics/find-violation-by-all-geofence",
      FIND_VIOLATION_BY_LICENSE_PLATE: "/api/analytics/find-violation-count-by-lpn",
      FIND_VIOLATION_BY_PEO_LAST_SHIFT: "/api/analytics/find-violation-by-peo-last-shift",
      FIND_VIOLATION_BY_ALL_PEO: "/api/analytics/find-violation-by-peo",
      FIND_PEO_LAST_LOCATION: "/api/analytics/find-peo-last-location",
      FIND_LPR_LOCATION_AND_GEOFENCE: "/api/analytics/find-all-lpr-by-organization"
    },
    LPR_PROPERTY: {
      ADD_PROPERTY:"/api/property/add",
      UPDATE_PROPERTY:"/api/property/update",
      DELETE_PROPERTY_BY_ID:"/api/property/delete/",
      FIND_PROPERTY_BY_ID:"/api/property/find/",
      FIND_ALL:"/api/property/find-all",
    },
    LPR_SUB_PROPERTY: {
      ADD_SUB_PROPERTY:"/api/sub-property/add",
      UPDATE_SUB_PROPERTY:"/api/sub-property/update",
      DELETE_SUB_PROPERTY_BY_ID:"/api/sub-property/delete/",
      FIND_SUB_PROPERTY_BY_ID:"/api/sub-property/find/",
      FIND_ALL:"/api/sub-property/find-all",
      FIND_ALL_BY_PROPERTY_ID:"/api/sub-property/find-all-by-property-id/"
    },
    PAYMENT_DETAIL: {
      SEARCH: "/api/spot/payment/search"
    },
    CITATION: {
      FIND_ALL: "/api/citation/find-all",
      CITATION_BY_ID: "/api/citation/find-by-id/"
    },
    ENFORCEMENT_VEHICLE: {
      FIND_ALL: "/api/vehicle/find-all",
      ADD_VEHICLE: "/api/vehicle/add",
      UPDATE_VEHICLE: "/api/vehicle/update",
      DELETE_VEHICLE: '/api/vehicle/delete/'
    },
    EVENT_MANAGEMENT: {
      FIND_ALL_UPCOMING: "/api/events/find-upcoming-events",
      ASSIGN_EVENT_PEO: "/api/events/assign-peo",
      FIND_PEO_BY_EVENT_ID: "/api/events/find-peo-by-event-id",   // find-peo-by-event-id/id
      REMOVE_PEO_FROM_EVENT: "/api/events/remove-peo"
    },
    PAYMENT_TESTING: {
      ADD_LPN_PAYMENT: "/api/lpr-raw/add-mock-lpn",
      FIND_ALL_LPN_PAYMENT: "/api/lpr-raw/find-test-payments",
      ADD_MULTIPLE_LPN_PAYMENT : "/api/lpr-raw/add-list-mock-lpn",
    },
    CONFIGURATION: {
      FIND_ALL_TICKET_PRICE: "/api/violationticketprice/find-all",
      ADD_TICKET_PRICE:     "/api/violationticketprice/add",
      UPDATE_TICKET_PRICE: "/api/violationticketprice/update",
      DELETE_TICKET_PRICE: "/api/violationticketprice/delete/"
    },
  },
  WEB_URL: {
    HOME: "",
    LOGIN: "/login",
    ADD_NEW_PASSWORD: "/add-new-password",
    FORGOT_PASSWORD: "/forget-password",
    FORGOT_USERNAME: "/forget-username",
    USER: "/user",
    USER_PROFILE: "/user/user-profile",
    CHANGE_PASSWORD: "/user/change-password",
    ORGANIZATION: "/organization",
    ORGANIZATION_MANAGEMENT: "/organization-management",
    SHIFT_DETAIL: "/shift-details",
    LPR_REGISTERED_VEHICLE: "/lpr-config/registered-vehicle",
    LPR_VIOLATION: "/lpr-data/violation",
    LPR_CAMERA_GROUP: "/lpr-config/camera-group",
    LPR_CAMERA_LIST: "/lpr-config/camera-list",
    LPR_SESSION_DATA: "/lpr-data/session-data",
    LPR_PROPERTY: "/lpr-config/property",
    GEOFENCE: "/geofence",
    GEOFENCE_DETAIL: "/interactive-geofence",
    ZONE: "/zone-management",
    GATEWAY_DATA_DETAILS: "/gateway-data-details",
    PAYMENT_DETAILS: "/payment-details",
    PERMIT_DETAILS: "/permit-details",
    PAYMENT_API_DETAILS: "/payment-api-details",
    ALL_GEOFENCE: "/all-geofence",
    SHIFT_CHART: "/chart-shift-detail",
    SHIFT_CHART_DAILY: "/chart-daily-shift-details",
    DASHBOARD: "/dashboard",
    DASHBOARD_SUPER: "/dashboard-super",
    DASHBOARD_ORG: "/dashboard-organization",
    CITATION_MANAGEMENT: "/citation-management",
    ENFORCEMENT_VEHICLE: "/enforcement-vehicle",
    EVENT_MANAGEMENT: "/event-management",
    PAYMENT_TESTING: "/payment-testing"
  },
  WEB_SOCKET: {
    ENDPOINT: {
      WEB_NOTIFICATON: "/web-notification"
    },
    TOPIC: {
      MAP: "",
      RTM_NOTIFICATION: "/topic/rtmonitoring-notification",
      DEVICE_METRICS: "",
      SENSOR: "",
      WEB_NOTIFICATION: "/topic/web-notification",
      PARKING_SPOT_NOTIFICATION: "/topic/parkingspot-notification",
      SESSION_EXPIRED_NOTIFICATION: "/topic/session-expired-notification",
      CLIENT_NOTIFICATION: "/topic/client-notification",
      PAYMENT_NOTIFICATION: "/topic/payment-notification",
      REPORT_NOTIFICATION: ""
    },
    PAYLOAD_TYPE: {
      MESSAGE: "MESSAGE"
    }
  },
  MENU_NAMES : {
    PROJECT_NAME: "OLIOS Recovery",
    ORGANIZATION: "Organization Management",
    REGISTERED_VEHICLE: "Digital Permit Management",
    SHIFT_DETAIL: "Shift Details",
    CAMERA_GROUP: "Camera Group Management",
    CAMERA_LIST: "Camera Management",
    USER: "User Management",
    ZONE: "Zone Management",
    GEOFENCE: "Geofence Management",
    LICENSE_PLATE_SEARCH: "Plate Lookup",
    PAYMENT_DETAIL_SEARCH: "Payment Details",
    PERMIT_DETAIL_SEARCH: "Permit Details",
    ALL_GEOFENCE: "All Geofences",
    ORGANIZATION_MANAGEMENT: "Organization Management",
    SHIFT_CHART: "Monthly Statistics",
    SHIFT_CHART_DAILY: "Daily Statistics",
    DASHBOARD: "Dashboard",
    DASHBOARD_SUPER: "Super Dashboard",
    DASHBOARD_ORG: "Dashboard",
    CITATION_MANAGEMENT: "Citation Management",
    ENFORCEMENT_VEHICLE: "Enforcement Vehicle",
    EVENT_MANAGEMENT: "Event Management",
    PAYMENT_TESTING: "Payment Testing",
    CONFIGURATION: "Configuration"
  },
  COPY_RIGHT : {
    YEAR: "2022"
  }

};
